import {SearchContainer} from '../core/definitions/search-container';
import {SearchResultViewType} from '../core/definitions/search-result-view-type.enum';
import {OperationExecutorType} from '../core/definitions/operation-executor-type.enum';
import {OperationTarget} from '../core/definitions/operation-target.enum';
import {MetaField} from '../core/definitions/meta-field';
import {MetaTypes} from '../core/definitions/meta-types';

export const PROCEDURE_EXCEL_ALL_OBJECTS = 'alle objekter';

export interface ContentListReportFieldParams {
  list_field_template_id?: string;
  overview_fields?: MetaField[];
  combine_horizontal: boolean;
}

export interface ProcedureExcelFooter {
  procedure_name: string;
  procedure_status: string;
  list_field_template_name?: string;
}

export interface SourceObjectExcelFooter {
  source_object_name: string;
}

export function listFieldTemplateName(
  template: {artifact_name?: string; group_name?: string} | null | undefined,
): string | undefined {
  return textValue(template?.artifact_name) || textValue(template?.group_name);
}

export function procedureExcelFooter(source: {
  metaType?: string;
  procedureName?: string;
  statusName?: string;
  listFieldTemplateName?: string;
} | null | undefined): ProcedureExcelFooter | null {
  const procedureName = textValue(source?.procedureName);
  const statusName = textValue(source?.statusName);
  if (source?.metaType !== MetaTypes.SPECTRUM_PROCEDURE || !procedureName || !statusName) {
    return null;
  }
  const footer: ProcedureExcelFooter = {
    procedure_name: procedureName,
    procedure_status: statusName,
  };
  const templateName = textValue(source.listFieldTemplateName);
  if (templateName) {
    footer.list_field_template_name = templateName;
  }
  return footer;
}

export function sourceObjectExcelFooter(source: {
  operationTarget?: string;
  metaType?: string;
  objectName?: string;
} | null | undefined): SourceObjectExcelFooter | null {
  const objectName = textValue(source?.objectName);
  if (source?.operationTarget !== OperationTarget.CONTENT_LIST_VIEW || !objectName) {
    return null;
  }
  if (source.metaType === MetaTypes.SPECTRUM_PROCEDURE) {
    return null;
  }
  return {source_object_name: objectName};
}

function textValue(value: string | undefined): string | undefined {
  if (typeof value !== 'string') {
    return undefined;
  }
  const text = value.trim();
  return text || undefined;
}

export function contentListRefreshesAfterClose(refreshView: boolean, executorType: string | undefined): boolean {
  return refreshView === true && executorType !== OperationExecutorType.REPORT;
}

export function contentListReportFieldParams(
  searchContainer: SearchContainer | null | undefined,
): ContentListReportFieldParams | null {
  if (!searchContainer || searchContainer.searchResultViewName !== SearchResultViewType.LIST) {
    return null;
  }
  const fields = searchContainer.currentPathView?.search_view?.overview_fields;
  const hasFields = Array.isArray(fields) && fields.length > 0;
  if (!hasFields && !searchContainer.listFieldTemplateId) {
    return null;
  }
  const params: ContentListReportFieldParams = {combine_horizontal: false};
  if (hasFields) {
    params.overview_fields = fields;
  }
  if (searchContainer.listFieldTemplateId) {
    params.list_field_template_id = searchContainer.listFieldTemplateId;
  }
  return params;
}
